export const SCALES_FALLBACK_MIN_RANGE = 0;
export const SCALES_FALLBACK_MAX_RANGE = 10;
